// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-course-container {
  margin: 50px auto;
  max-width: 600px;
  background-color: #fff3cd;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}


.create-course-container h1 {
  text-align: center;
}

.create-course-container form {
  margin-top: 20px;
}

.create-course-container select {
  width: 100%;
}

@media (max-width: 576px) {
  .create-course-container {
    margin: 20px;
    padding: 10px;
    max-width: 100%;
  }
}

.create-course-module {
  background-color: #a56dff;
  margin: 50px auto;
  max-width: 600px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.create-course-module h2 {
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

.create-course-module .form-group {
  margin-bottom: 20px;
}

.create-course-module label {
  color: white;
}

.create-course-module input {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}

.create-course-module select {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}


.create-lesson-activity {
  background-color: #ec88b7;
  margin: 50px auto;
  max-width: 600px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.create-lesson-activity h2 {
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

.create-lesson-activity .form-group {
  margin-bottom: 20px;
}

.create-lesson-activity label {
  color: white;
}

.create-lesson-activity input {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}

.create-lesson-activity select {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}



.create-lesson-plan {
  background-color: rgb(114, 176, 235);
  margin: 50px auto;
  max-width: 600px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.create-lesson-plan h2 {
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

.create-lesson-plan .form-group {
  margin-bottom: 20px;
}

.create-lesson-plan label {
  color: white;
}

.create-lesson-plan input {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}

.create-lesson-plan select {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}


.create-lesson-project {
  background-color: #fdee98;
  margin: 50px auto;
  max-width: 600px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.create-lesson-project h2 {
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

.create-lesson-project .form-group {
  margin-bottom: 20px;
}

.create-lesson-project label {
  color: white;
}

.create-lesson-project input {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}

.create-lesson-project select {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}


.create-module-lesson {
  background-color: #aae797;
  margin: 50px auto;
  max-width: 600px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.create-module-lesson h2 {
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

.create-module-lesson .form-group {
  margin-bottom: 20px;
}

.create-module-lesson label {
  color: white;
}

.create-module-lesson input {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}

.create-module-lesson select {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}


.create-module-project {
  background-color: #fd98b6;
  margin: 50px auto;
  max-width: 600px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.create-module-project h2 {
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

.create-module-project .form-group {
  margin-bottom: 20px;
}

.create-module-project label {
  color: white;
}

.create-module-project input {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}

.create-module-project select {
  border-radius: 10px;
  border: none;
  padding: 10px;
  width: 100%;
  background-color: white;
}

.create-lesson-activity .twobutton {
  margin-top: 20px;
  padding-top: 10px;
}

.modalStyle {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  padding: 20px;
  border: 1px solid #ccc;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 400px;
  max-height: 500px;
  overflow-y: auto;
  border-radius: 30px;
}

.my-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 3%;
}

.save-button {
  max-width: 15vw;
  padding: 3% 6%;
  background-color: white;
  font-weight: bold;
  color: #03b4c6;
  font-family: sans-serif;
  border: 2px solid #03b4c6;
  border-radius: 1vh;
  margin: 1% 0;
  text-align: center;
  word-wrap: break-word;
}

@media (max-width: 768px) {
  .save-button {
    max-width: 30vw;
    padding: 5% 10%;
  }
}

@media (max-width: 480px) {
  .save-button {
    max-width: 50vw;
    padding: 7% 12%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageContent/managecontentforms/managecontentstyle/managecontent.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;;;AAIA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":[".create-course-container {\n  margin: 50px auto;\n  max-width: 600px;\n  background-color: #fff3cd;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n}\n\n\n.create-course-container h1 {\n  text-align: center;\n}\n\n.create-course-container form {\n  margin-top: 20px;\n}\n\n.create-course-container select {\n  width: 100%;\n}\n\n@media (max-width: 576px) {\n  .create-course-container {\n    margin: 20px;\n    padding: 10px;\n    max-width: 100%;\n  }\n}\n\n.create-course-module {\n  background-color: #a56dff;\n  margin: 50px auto;\n  max-width: 600px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n}\n\n.create-course-module h2 {\n  color: white;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.create-course-module .form-group {\n  margin-bottom: 20px;\n}\n\n.create-course-module label {\n  color: white;\n}\n\n.create-course-module input {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n.create-course-module select {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n\n.create-lesson-activity {\n  background-color: #ec88b7;\n  margin: 50px auto;\n  max-width: 600px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n}\n\n.create-lesson-activity h2 {\n  color: white;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.create-lesson-activity .form-group {\n  margin-bottom: 20px;\n}\n\n.create-lesson-activity label {\n  color: white;\n}\n\n.create-lesson-activity input {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n.create-lesson-activity select {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n\n\n.create-lesson-plan {\n  background-color: rgb(114, 176, 235);\n  margin: 50px auto;\n  max-width: 600px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n}\n\n.create-lesson-plan h2 {\n  color: white;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.create-lesson-plan .form-group {\n  margin-bottom: 20px;\n}\n\n.create-lesson-plan label {\n  color: white;\n}\n\n.create-lesson-plan input {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n.create-lesson-plan select {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n\n.create-lesson-project {\n  background-color: #fdee98;\n  margin: 50px auto;\n  max-width: 600px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n}\n\n.create-lesson-project h2 {\n  color: white;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.create-lesson-project .form-group {\n  margin-bottom: 20px;\n}\n\n.create-lesson-project label {\n  color: white;\n}\n\n.create-lesson-project input {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n.create-lesson-project select {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n\n.create-module-lesson {\n  background-color: #aae797;\n  margin: 50px auto;\n  max-width: 600px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n}\n\n.create-module-lesson h2 {\n  color: white;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.create-module-lesson .form-group {\n  margin-bottom: 20px;\n}\n\n.create-module-lesson label {\n  color: white;\n}\n\n.create-module-lesson input {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n.create-module-lesson select {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n\n.create-module-project {\n  background-color: #fd98b6;\n  margin: 50px auto;\n  max-width: 600px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n}\n\n.create-module-project h2 {\n  color: white;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.create-module-project .form-group {\n  margin-bottom: 20px;\n}\n\n.create-module-project label {\n  color: white;\n}\n\n.create-module-project input {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n.create-module-project select {\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  background-color: white;\n}\n\n.create-lesson-activity .twobutton {\n  margin-top: 20px;\n  padding-top: 10px;\n}\n\n.modalStyle {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #ffffff;\n  padding: 20px;\n  border: 1px solid #ccc;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  width: 400px;\n  max-height: 500px;\n  overflow-y: auto;\n  border-radius: 30px;\n}\n\n.my-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 3%;\n}\n\n.save-button {\n  max-width: 15vw;\n  padding: 3% 6%;\n  background-color: white;\n  font-weight: bold;\n  color: #03b4c6;\n  font-family: sans-serif;\n  border: 2px solid #03b4c6;\n  border-radius: 1vh;\n  margin: 1% 0;\n  text-align: center;\n  word-wrap: break-word;\n}\n\n@media (max-width: 768px) {\n  .save-button {\n    max-width: 30vw;\n    padding: 5% 10%;\n  }\n}\n\n@media (max-width: 480px) {\n  .save-button {\n    max-width: 50vw;\n    padding: 7% 12%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
